import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { StudioOfferingApiClientContext } from './studio-offering.context';
import { StudioOfferingQueriesConfig } from './studio-offering.queries';
export const StudioOfferingApiClient = {
  ...createApiClient(StudioOfferingQueriesConfig),
  context: StudioOfferingApiClientContext
};
//# sourceMappingURL=studio-offering.api-client.js.map